import React from "react";
import { graphql } from "gatsby";

import Layout from "../../../components/Layout";
import WithI18next from "../../../components/WithI18next";

import LearnLayout from "../../../layouts/LearnLayout";

const LearnPage = ({ data, t }) => {
  return (
    <Layout
      title={t("learn.seo.title")}
      description={t("learn.seo.description")}
    >
      <LearnLayout data={data} />
    </Layout>
  );
};

export default WithI18next()(LearnPage);

export const query = graphql`
  query (
    $wpLocale: String!
    $wpGlobalConfig: String!
    $isThai: Boolean = false
  ) {
    ...GetOnBoardContent

    learnIcon: file(relativePath: { eq: "images/menus/icons/learn.svg" }) {
      publicURL
    }

    heroContent: allWpHeroSectionItem(
      filter: {
        language: { locale: { eq: $wpLocale } }
        acfGlobalConfiguration: { gcLinkTo: { eq: $wpGlobalConfig } }
        acfHeroSections: { hsPage: { eq: "learn" } }
      }
    ) {
      edges {
        node {
          acfHeroSections {
            hsMainHeading
            hsMainText
          }
        }
      }
    }

    articles: allWpPost(
      filter: {
        categories: {
          nodes: {
            elemMatch: { wpParent: { node: { slug: { regex: "/articles/" } } } }
          }
        }
        language: { locale: { eq: $wpLocale } }
        acfGlobalConfiguration: { gcLinkTo: { in: [".all", $wpGlobalConfig] } }
      }
      sort: { order: DESC, fields: date }
    ) {
      ...Post
    }
    articleCategories: allWpCategory(
      filter: {
        slug: { regex: "/articles/" }
        language: { locale: { eq: $wpLocale } }
      }
    ) {
      nodes {
        databaseId
        wpChildren {
          nodes {
            databaseId
            slug
            acfCategories {
              catShowOnFilter
            }
          }
        }
      }
    }
    podcasts: allWpPost(
      filter: {
        categories: {
          nodes: {
            elemMatch: { wpParent: { node: { slug: { eq: "podcasts" } } } }
          }
        }
        language: { locale: { eq: $wpLocale } }
        acfGlobalConfiguration: { gcLinkTo: { in: [".all", ".co.th"] } }
      }
      sort: { order: DESC, fields: date }
      limit: 3
    ) @include(if: $isThai) {
      ...Post
    }

    youtubeLinks: allWpYoutubeItem(
      filter: {
        acfGlobalConfiguration: { gcLinkTo: { in: [".all", $wpGlobalConfig] } }
      }
      sort: { order: ASC, fields: date }
    ) {
      nodes {
        acfYoutube {
          link
          caption
          duration
          date
        }
      }
    }

    youtubeChannel: allWpPartialItem(
      filter: {
        language: { locale: { eq: $wpLocale } }
        acfGlobalConfiguration: { gcLinkTo: { in: [".all", $wpGlobalConfig] } }
        acfPartials: { pPartialId: { eq: "learn-youtube-channel" } }
      }
    ) {
      nodes {
        acfPartials {
          pHeading
          pButtonText
          pButtonUrl
          pIcon {
            localFile {
              publicURL
            }
          }
        }
      }
    }

    subscribeBannerContent: allWpPartialItem(
      filter: {
        language: { locale: { eq: $wpLocale } }
        acfGlobalConfiguration: { gcLinkTo: { in: [".all", $wpGlobalConfig] } }
        acfPartials: { pPartialId: { eq: "learn-subscribe-banner" } }
      }
    ) {
      edges {
        node {
          acfPartials {
            pHeading
            pIntroHeading
            pContent
            pButtonText
            pIcon {
              localFile {
                publicURL
              }
            }
          }
        }
      }
    }
  }
`;
